import React from 'react';

const IconFreelancer = () => (
  <svg fill="none" role="img" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Freelancer</title>
    <path d="M9.832 16.769l4.128 4.434 4.552-4.461 1.412-8.313-5.547-0.285zM9.323 16.254l4.37-8.15-12.689-0.689zM6.158 4.849l1.071 2.199 5.916 0.367zM17.772 4.848l-2.988 2.692 5.026 0.187zM7.881 27.152l5.591-5.466-3.364-3.611zM18.619 4.848l2.042 2.864 10.334-2.864z"></path>
  </svg>
);

export default IconFreelancer;
